import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import vueFilePond from 'vue-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { ref } from 'vue';

import { props as propsDefinition } from './filepond.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkFilePond',
  props: propsDefinition,
  setup(__props, { expose }) {

const props = __props


const filePond = vueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType);
const filePondRef = ref<typeof filePond>();

expose({ filePond: filePondRef });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(filePond), _mergeProps({
    ref_key: "filePondRef",
    ref: filePondRef
  }, {
      credits: '',
      ...props.options,
      ..._ctx.$attrs
    }), null, 16))
}
}

})